"use client";

import { BlogFaqItem } from "@v2/types/blog";
import { Accordion, AccordionDetails, AccordionSummary, Box, colors, Grid2 as Grid, Typography } from "@mui/material";
import { ChevronDown } from "lucide-react";

export default function BlogFaq({ items }: { items: BlogFaqItem[] }) {
    if (!items.length) return null;

    const left  = items.filter((_, i) => i % 2 === 0);
    const right = items.filter((_, i) => i % 2 === 1);

    return (
        <Box component="section" sx={{ mt: 2, bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 } }}>
            <Typography component="h2" sx={{ fontSize: { xs: 17, md: 21 }, fontWeight: 600, color: colors.grey[800], mb: 2, textAlign: "center" }}>
                سوالات متداول
            </Typography>
            <Grid container spacing={{ xs: 0, md: 2 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    {left.map((faq) => <FaqItem key={faq.id} faq={faq} />)}
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    {right.map((faq) => <FaqItem key={faq.id} faq={faq} />)}
                </Grid>
            </Grid>
        </Box>
    );
}

function FaqItem({ faq }: { faq: BlogFaqItem }) {
    return (
        <Accordion elevation={0} sx={{
            "&::before": { opacity: "0 !important", height: 0 },
            margin: "0 !important",
            mb: 0.5,
            borderTop: "1px solid",
            borderColor: colors.grey[300],
            borderRadius: "0 !important",
        }}>
            <AccordionSummary expandIcon={<ChevronDown size={18} color={colors.grey[600]} />} sx={{
                pr: 0,
                pl: 0
            }}>
                <Typography sx={{ fontWeight: 400, color: colors.grey[900], fontSize: { xs: 13, md: 15 } }}>
                    {faq.question}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0, px: 0 }}>
                <Typography sx={{ fontSize: { xs: 12, md: 14 }, color: colors.grey[700], lineHeight: 1.8, whiteSpace: "pre-line", pb: 1 }}>
                    {faq.answer}
                </Typography>
            </AccordionDetails>
        </Accordion>
    );
}
